import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientProfileScreen } from 'screens/patient';

export default withPermissions(PatientProfileScreen, [
  GroupSecurity.PatientRead,
]);
